import invoices from '@/api/apiSferest/services/invoices'
import i18n from '@/i18n'
import session from '@/auth/session'
import { _isGreater, _times, _percentage } from '@/helpers/bigNumber'
import idWithZeros from '@/helpers/idWithZeros'
import { formatDate, formatNow } from '@/helpers/formatDate'
import { modifyInvoiceTags } from '@/helpers/formatInvoice'
import { getUserSubscription, getPromoterCode } from '@/utils/tokenUtils'
import store from '@/store'

const MAX_AMOUNT = 99999999
const MAX_FILE = 8 * 1024 * 1024

/**
 * Save invoice by Type
 * @param {String} type - Invoice type.
 */
export const save = ({ commit, state, getters, dispatch }, type) => { 
  return new Promise((resolve, reject) => {
    dispatch('errors/empty', {}, { root: true }).then(() => {
      cleanContactType('client', getters, dispatch)
      cleanContactType('customer', getters, dispatch)
      cleanContactType('agent', getters, dispatch)

      if (!validateContactDir3(getters, 'client') || !validateContactDir3(getters, 'agent')) {
        const msg = i18n.t('invoices.save.errors.dir3Info')
        dispatch('errors/addValidationError', { msg }, { root: true })
        reject(new Error(msg))
        return
      }

      const draft = getters.apificate
      if (_isGreater(draft.total, MAX_AMOUNT)) {
        const msg = i18n.t('invoices.save.errors.maxAmount')
        dispatch('errors/addValidationError', { msg }, { root: true })
        reject(new Error(msg))
        return
      }
      let totalSize = 0
      var list = getters['files/getArray']
      Promise.all([
        ...list.map(x => {
          // solo se comprueba los nuevos
          // si con los que ya había son más de lo permitido el CORE suelta error
          if (x.size !== undefined) {
            totalSize += x.size
          }
        })
      ])
      if (_isGreater(totalSize, MAX_FILE)) {
        const msg = i18n.t('invoices.save.errors.maxSize')
        dispatch('errors/addValidationError', { msg }, { root: true })
        reject(new Error(msg))
        return
      }
      if (!draft.invoiceId.serie && !draft.invoiceId.number && state.id && !state.toDuplicate) {
        draft.invoiceId.number = idWithZeros(state.id)
      }
      let action = state.id && !state.toDuplicate ? 'update' : 'create'
      invoices[action][type](draft, state.id)
      .then((res) => {
        let id = state.id
                  ? state.id
                  : res.data
                    ? res.data.id
                    : null
        commit('SET_ID', id)
        commit('SET_EDITING', false)
        if (!state.status) {
          commit('SET_STATUS', '1')
        }
        dispatch('files/save', id).then(resFiles => {
          resolve(res)
        }, err => {
          dispatch('errors/addValidationError', { err }, { root: true })
          reject(new Error(err))
        })
      }, (err) => {
        dispatch('errors/addValidationError', { err }, { root: true })
        reject(new Error(err))
      })
    })
  })
}

/**
 * Cleans contact type
 * @param {*} type  Type of contact
 * @param {*} getters Getters
 * @param {*} dispatch  Dispatch method
 */
function cleanContactType(type, getters, dispatch) {
  const dirType = getters[`${type}/dirType`]
  if (dirType === 'faceb2b') {
    // dispatch(`${type}/accountingOffice/empty`)
    // dispatch(`${type}/managerBody/empty`)
    // dispatch(`${type}/processingUnit/empty`)
    // dispatch(`${type}/proponentBody/empty`)
  } else if (dirType === 'face') {
    dispatch(`${type}/FACeB2B/empty`)
  } else if (dirType === 'noFace') {
    dispatch(`${type}/accountingOffice/empty`)
    dispatch(`${type}/managerBody/empty`)
    dispatch(`${type}/processingUnit/empty`)
    dispatch(`${type}/proponentBody/empty`)
    dispatch(`${type}/FACeB2B/empty`)
  }
}

/**
 * Validate Dir 3 by types
 * @param {Array} types - List of types to validate.
 */
export const validateDir3 = ({ getters }, types) => {
  for(let contact of types) {
    if(!validateContactDir3(getters, contact)) {
      return false
    }
  }
  return true
}

/**
 * Validates contact DIR3 info
 * @param {*} getters Getters
 * @param {*} type  Contact type
 * @return {Boolean} true if info is valid, false in other case
 */
const validateContactDir3 = (getters, type) => {
  const dirType = getters[`${type}/dirType`]
  if (dirType === 'face') {
    const accountingOffice = getters[`${type}/accountingOffice/apificate`]
    const managerBody = getters[`${type}/managerBody/apificate`]
    const processingUnit = getters[`${type}/processingUnit/apificate`]
    return (accountingOffice && managerBody && processingUnit &&
              accountingOffice.code && managerBody.code && processingUnit.code)
  }
  return true
}

/**
 * Dispatch an error into store
 * @param {*} commit  Last change
 * @param {*} getters Getters
 * @param {*} dispatch  Dispatch method
 * @param {*} state Current state
 * @param {*} type  Type
 * @param {*} force Whether to force error or not
 * @return {Promise} Asynchronous wrapper
 */
export const issue = ({ commit, getters, dispatch, state }, { type, force }) => {
  return new Promise((resolve, reject) => {
    dispatch('errors/empty', {}, { root: true }).then(() => {
      if (session.isApiLogin() && !session.isSupportSession()) {
        store.dispatch('me/get').then(() => {
          const issuedInvoices = store.state.me.issuedInvoices
          const maxFreeIssuedInvoices = store.state.me.maxIssuedInvoices
          if (getPromoterCode() === '9900' && getUserSubscription() === 'FREE' && issuedInvoices >= maxFreeIssuedInvoices) {
            return dispatch('errors/addMaxFreeIssuedError', { msg: i18n.tc('invoices.issue.errors.maxInvoicesIssued', 2, [maxFreeIssuedInvoices]) }, { root: true })
          }
          return dispatchSaveIssueInvoice(resolve, reject, commit, dispatch, state, type, force)
        })
      } else {
        return dispatchSaveIssueInvoice(resolve, reject, commit, dispatch, state, type, force)
      }
    })
  })
}

/**
 * Executes the error
 * @param {*} resolve Promise resolve method
 * @param {*} reject  Promise reject method
 * @param {*} commit  Last change
 * @param {*} dispatch  Store dispatch
 * @param {*} state Store state
 * @param {*} type  Invoice type
 * @param {*} force Whether to force change
 */
function dispatchSaveIssueInvoice(resolve, reject, commit, dispatch, state, type, force) {
  dispatch('save', type).then((res) => {
    let id
    if (state.toDuplicate) {
      id = res.data.id
    } else {
      id = state.id ? state.id : res.data ? res.data.id : null
    }
    if (!id) {
      return dispatch('errors/addServerError', { msg: i18n.t('invoices.issue.errors.tryAgain') }, { root: true }).then(
        reject(new Error('id not found'))
      )
    }

    const params = {
      id: [id]
    }
    const body = {
      status: 'issue',
      force
    }

    invoices.submit[type](body, params).then((res) => {
      resolve(res)
    }, err => {
      /*
      When response is 303 (See_Other), user is routed to provided assets info.
      Note: 304 code cannot be used because CORS is not accepted.
      */
      if (err.request && err.request.status === 303) {
        return dispatch('errors/empty', {}, { root: true }).then(() => {
          commit('SET_SHOWINVOICEASSETS', true)
          resolve()
        })
      }
      reject(err)
    })
  }, err => {
    reject(err)
  })
}

/**
 * Handles rectification on an issue
 * @param {*} state Current stat
 * @param {*} commit Method
 * @param {*} dispatch Method
 * @param {*} type Type
 * @param {*} force Boolean
 * @return {Promise} Wrapper
 */
export const issueRectified = ({ state, commit, dispatch }, { type, force }) => {
  return new Promise((resolve, reject) => {
    dispatch('errors/empty', {}, { root: true }).then(() => {
      dispatch('issue', { type, force }).then((res) => {
        resolve(res)
      }, err => {
        /*
          When response is 303 (See_Other), user is routed to provided assets info.
          Note: 304 code cannot be used because CORS is not accepted.
        */
        if (err.request && err.request.status === 303) {
          return dispatch('errors/empty', {}, { root: true }).then(() => {
            commit('SET_SHOWINVOICEASSETS', true)
            resolve()
          })
        }
        reject(err)
      })
    })
  })
}

/**
 * Get invoice details
 * @param {*} commit Method
 * @param {*} dispatch Method
 * @param {*} state State
 * @param {*} payload Service response
 */
export const getSingleInvoice = ({ commit, dispatch, state }, payload) => {
  return new Promise((resolve, reject) => {
    dispatch('errors/empty', {}, { root: true }).then(() => {
      invoices.get[payload.invoiceType](payload.id).then(res => {
        var invoice = res.data
        modifyInvoiceTags(invoice)
        invoice._invoiceType = payload.invoiceType
        invoices.getAttachments(payload.id).then(res => {
          invoice.files = res.data
          resolve(invoice)
        })
      })
    })
  })
}

// solo verifica que exista esta factura para los parametros de entrada
export const getRectifying = ({ commit, dispatch, state }, payload) => {
  return invoices.get[payload.invoiceType](payload.id).then(res => {
      return res.data
    })
}

/**
 * Import invoice
 * @param {Object} payload - Invoice Object information.
 */
export const importInvoice = ({ commit, dispatch }, payload) => {
  return new Promise((resolve, reject) => {
    dispatch('errors/empty', {}, { root: true }).then(() => {
      invoices.import(payload).then((res) => {
        resolve(res.data)
      }, (err) => {
        reject(err.response.data)
      })
    })
  })
}

/**
 * Clears store
 * @param {*} commit  Method
 * @param {*} dispatch  Method
 * @return {Promise} Wrapper
 */
export const empty = ({ commit, dispatch }) => {
  return new Promise((resolve, reject) => {
    commit('SET_FORMAT', 'CM10')
    commit('SET_CREATED', formatNow())
    commit('SET_ISSUE', null)
    commit('SET_INCOMEDATE', null)
    commit('SET_PERIOD_START', null)
    commit('SET_PERIOD_END', null)
    commit('SET_EDITING', false)
    commit('SET_ID_SERIE', '')
    commit('SET_ID_NUMBER', '')
    commit('SET_ID', null)
    commit('SET_PROCEDURE_NUMBER', undefined)
    commit('SET_PROCEDURE_REASON', 1)
    commit('SET_CONCEPT', '')
    commit('SET_FUND_PROVISION', null)
    commit('SET_RECTIFIED_REASON', 1)
    commit('SET_RECTIFIED_NUMBER', null)
    commit('SET_RECTIFIED_SERIE', null)
    commit('SET_RECTIFIED_DESCRIPTION', null)
    commit('SET_TO_RECTIFY', false)
    commit('SET_TO_DUPLICATE', false)
    commit('SET_STATUS', null)
    commit('SET_LOCATORCODE', null)
    commit('SET_INVOICETYPE', undefined)
    commit('SET_TYPE', undefined)
    commit('SET_PARENT_ID', undefined)
    commit('SET_CHECKINMOBILIZED', false)
    commit('SET_DOBILLID', true)
    Promise.all([
      dispatch('files/empty'),
      dispatch('files/emptyForm'),
      dispatch('provider/empty'),
      dispatch('client/empty'),
      dispatch('customer/empty'),
      dispatch('agent/empty'),
      dispatch('details/empty'),
      dispatch('discountsCharges/empty'),
      dispatch('paymentsSpentsOthers/empty'),
      dispatch('thirdPartyInvoices/empty'),
      dispatch('paymentIndications/empty'),
      // factoring
      dispatch('factoringContact/empty'),
      dispatch('factoringReferences/empty'),
      dispatch('factoringTransferDocuments/empty'),
      dispatch('factoringPaymentData/empty'),
      dispatch('FACeB2B/empty')
    ]).then(() => {
      commit('SET_CUSTOMERASCLIENT', true)
      commit('SET_DOBILLPERIOD', false)
      // commit('SET_DOBILLPROCEDURE', false)
      commit('SET_ONLYSUPPLIED', false)
      commit('SET_SHOWINVOICEASSETS', false)
      resolve()
    })
  })
}

/**
 * Adds third party invoices
 * @param {*} dispatch Method
 * @param {*} state State
 * @param {Array} invoices  Invoices
 * @return {Promise} Wrapper
 */
export const addThirdPartyInvoices = ({ dispatch, state }, invoices) => {
  return new Promise((resolve) => {
    dispatch('errors/empty', {}, { root: true }).then(() => {
      invoices.filter(i => !state.thirdPartyInvoices.list.some(y => i.id === y.id))
        .forEach(i => {
          const o = {}
          o.date = i.createDate
          o.provider = i.providerDocument
          o.invoiceId = i.serie ? i.number ? `${i.serie}${i.number}` : `${i.serie}` : i.number ? `${i.number}` : ''
          o.amount = i.amount
          o.id = i.id
          dispatch('thirdPartyInvoices/addItem', o)
        })
      resolve()
    })
  })
}

/**
 * Set invoice
 * @param {*} commit Method
 * @param {*} dispatch Method
 * @param {*} state Current state
 * @param {*} payload Service respose
 * @return {Promise} Wrapper
 */
export const set = ({ commit, dispatch, state }, payload) => {
  return new Promise((resolve, reject) => {
    dispatch('empty').then(() => {
      if (payload.created) payload.created = formatDate(payload.created)
      if (payload.issue) payload.issue = formatDate(payload.issue)
      if (payload.incomeDate) payload.incomeDate = formatDate(payload.incomeDate)
      commit('SET_ID', payload.id)
      // types: [ STANDARD, PAYMENT, RECTIFIED ]
      commit('SET_INVOICETYPE', payload._invoiceType)
      commit('SET_TYPE', payload.type)
      if (payload.type === 'RECTIFIED' && payload.paidRectified) {
        commit('SET_PARENT_ID', payload.paidRectified.rectifiedId)
        commit('SET_RECTIFIED_SERIE', payload.paidRectified.serie)
        commit('SET_RECTIFIED_NUMBER', payload.paidRectified.number)
        commit('SET_RECTIFIED_REASON', payload.paidRectified.reason)
        commit('SET_RECTIFIED_DESCRIPTION', payload.paidRectified.description)
      } else if (payload.type === 'PAYMENT' && payload.paidRectified) {
        commit('SET_PROCEDURE_NUMBER', payload.paidRectified.number)
        commit('SET_PROCEDURE_REASON', payload.paidRectified.reason)
        // commit('SET_DOBILLPROCEDURE', true)
      }

      commit('SET_FORMAT', payload.format)
      commit('SET_CREATED', payload.created)
      commit('SET_ISSUE', payload.issue)
      commit('SET_INCOMEDATE', payload.incomeDate)

      commit('SET_ONLYSUPPLIED', payload.onlySupplied)
      commit('SET_CHECKINMOBILIZED', payload.checkInmobilized)

      if (payload.billPeriod) {
        if (payload.billPeriod.start) payload.billPeriod.start = formatDate(payload.billPeriod.start)
        if (payload.billPeriod.end) payload.billPeriod.end = formatDate(payload.billPeriod.end)
        commit('SET_PERIOD_START', payload.billPeriod.start)
        commit('SET_PERIOD_END', payload.billPeriod.end)
        commit('SET_DOBILLPERIOD', !!payload.billPeriod.end || !!payload.billPeriod.start)
      }

      if (payload.invoiceId) {
        commit('SET_ID_SERIE', payload.invoiceId.serie)
        commit('SET_ID_NUMBER', payload.invoiceId.number)
      }

      const automaticId = idWithZeros(payload.id)
      commit('SET_ID_SERIE', payload.invoiceId.serie)
      if (!payload.invoiceId.serie && payload.invoiceId.number === automaticId) {
        commit('SET_DOBILLID', false)
      }
      commit('SET_CONCEPT', payload.concept)
      commit('SET_FUND_PROVISION', payload.fundProvision)

      if (payload.status) {
        commit('SET_STATUS', payload.status)
      }

      const proc = []
      if (payload.files) proc.push(dispatch('files/set', payload.files.map(x => ({ ...x, idI: payload.id }))))
      /* Invoice roles */
      if (payload.provider) proc.push(dispatch('provider/set', payload.provider))
      if (payload.client) proc.push(dispatch('client/set', payload.client))
      if (payload.customer) {
        commit('SET_CUSTOMERASCLIENT', false)
        proc.push(dispatch('customer/set', payload.customer))
      } else {
        commit('SET_CUSTOMERASCLIENT', true)
      }
      if (payload.agent) proc.push(dispatch('agent/set', payload.agent))
      /* Invoice details */
      if (payload.invoiceLines) proc.push(dispatch('details/set', payload.invoiceLines))
      else if (payload.details) proc.push(dispatch('details/set', payload.details))
      if (payload.discountsCharges) {
        payload.discountsCharges = payload.discountsCharges.map(x => {
          if (x.base !== payload.totalGross) x.base = payload.totalGross
          if (!x.amount && x.percent) x.amount = _times(x.base, _percentage(x.percent))
          return x
        })
      }
      if (payload.discountsCharges) proc.push(dispatch('discountsCharges/set', payload.discountsCharges))
      if (payload.paymentsSpentsOthers) proc.push(dispatch('paymentsSpentsOthers/set', payload.paymentsSpentsOthers))
      if (payload.thirdPartyInvoices) proc.push(dispatch('thirdPartyInvoices/set', payload.thirdPartyInvoices))
      if (payload.paymentIndications) proc.push(dispatch('paymentIndications/set', payload.paymentIndications))
      /* FACTORING */
      if (payload.factoringContact) proc.push(dispatch('factoringContact/set', payload.factoringContact))
      if (payload.factoringReferences) proc.push(dispatch('factoringReferences/set', payload.factoringReferences))
      if (payload.factoringPaymentData) proc.push(dispatch('factoringPaymentData/set', payload.factoringPaymentData))
      if (payload.factoringTransferDocuments) proc.push(dispatch('factoringTransferDocuments/set', payload.factoringTransferDocuments))
      if (payload.FACeB2B) proc.push(dispatch('client/FACeB2B/set', payload.FACeB2B))
      Promise.all(proc).then(() => {
        resolve()
      })
    })
  })
}

/**
 * Duplicate invoice
 * @param {Object} payload - Object Invoice from duplicate.
 */
export const duplicate = ({ commit, dispatch }, payload) => {
  return new Promise((resolve, reject) => {
    dispatch('errors/empty', {}, { root: true }).then(() => {
      if (payload.files) {
        delete payload.files
        payload.files = []
      }
      Promise.all([
        dispatch('set', payload)
      ]).then(() => {
        commit('SET_EDITING', true)
        commit('SET_ID_SERIE', null)
        commit('SET_ID_NUMBER', null)
        commit('SET_ID', payload.id)
        commit('SET_TO_DUPLICATE', true)
        commit('SET_STATUS', null)
        commit('SET_CREATED', formatNow())
        Promise.all([
          dispatch('thirdPartyInvoices/empty')
        ]).then(() => {
          resolve()
        })
      })
    })
  })
}

/**
 * Rectify invoice
 * @param {Object} payload - Invoice Object to rectify.
 */
export const rectify = ({ commit, dispatch }, payload) => {
  return new Promise((resolve, reject) => {
    dispatch('errors/empty', {}, { root: true }).then(() => {
      if (payload.files) {
        delete payload.files
        payload.files = []
      }
      Promise.all([
        dispatch('set', payload)
      ]).then(() => {
        commit('SET_TYPE', 'RECTIFIED')
        commit('SET_EDITING', true)
        commit('SET_RECTIFIED_NUMBER', payload.invoiceId.number)
        commit('SET_RECTIFIED_SERIE', payload.invoiceId.serie)
        commit('SET_ID_SERIE', null)
        commit('SET_ID_NUMBER', null)
        commit('SET_PARENT_ID', payload.id)
        commit('SET_ID', null)
        commit('SET_TO_RECTIFY', true)
        commit('SET_STATUS', null)
        Promise.all([
          dispatch('thirdPartyInvoices/empty')
        ]).then(() => {
          resolve()
        })
      })
    })
  })
}

/**
 * Edit invoice
 * @param {Object} payload - Invoice Object to edit.
 */
export const edit = ({ commit, dispatch }, payload) => {
  return new Promise((resolve, reject) => {
    dispatch('errors/empty', {}, { root: true }).then(() => {
      const params = {
        id: payload.id,
        invoiceType: payload.invoiceType
      }
      dispatch('getSingleInvoice', params).then((res) => {
        dispatch('set', res).then(() => {
          commit('SET_EDITING', true)
          if (payload.suppliedToEdit) commit('SET_SUPPLIEDTOEDIT', true)
          resolve()
        })
      })
    })
  })
}

export const setUserRole = ({ state, commit, dispatch, rootState }, role) => {
  return new Promise(resolve => {
    commit('SET_USER_ROLE', role)
    if (!state.editing) dispatch(`${role}/set`, rootState.me)
  })
}

export const loaded = ({ commit }) => {
  commit('SET_LOADED', true)
  return Promise.resolve(true)
}

export const rebaseGlobalDiscounts = ({ commit, getters }, id) => {
  return new Promise((resolve) => {
    commit('discountsCharges/SET_BASE', getters.linesBeforeTaxes)
    resolve()
  })
}
